import React, { useState, useEffect } from 'react'
import { Input, Checkbox, Tag, Tooltip } from 'antd'
import './index.less'
import { getAuth } from '../../../utils/global'

const { Search } = Input

const businessOptions = [{
	label: '酒店商品库',
	value: 1,
	disabled: false
},{
	label: '景区商品库',
	value: 2,
	disabled: false
},{
	label: '民宿商品库',
	value: 6,
	disabled: false
},{
	label: '知识产权数据库',
	value: 5,
	disabled: false
},{
	label: '创意文案库',
	value: 7,
	disabled: false
},{
	label: '攻略图文数据库',
	value: 8,
	disabled: true
},{
	label: '酒店点评数据库',
	value: 9,
	disabled: true
}]
const tags = [
	'希尔顿',
	'桂林',
	'北京;天安门',
	'维也纳酒店',
	'上海',
	'成都',
	'锦江之星',
	'度假公馆',
	'戏剧性的天空',
	'城市生活',
	'风景区',
	'摩洛哥',
	'夜晚',
	'棕榈树'
]
const LeadBusinessSearch = (props) => {
	const [searchValue, setSearchValue]= useState('')
	const [businessIdList, setBusinessIdList] = useState(props.businessIdList)
	//点击热搜词
	const clickTag = (val) => {
		setSearchValue(val)
		props.getSearch({
			businessIdList,
			sug: val
		})
	}
	useEffect(() => {
		getAuth('function').then(res => { // 方法权限
			const canReadBussines = res.find(item => item.resourceVal === 'canReadBussines')
			if(canReadBussines) {
				setSearchValue('摩洛哥')
				props.getSearch({
					businessIdList,
					sug: '摩洛哥'
				})
			}
		})
	}, [])
	// 输入关键词
	const changeSearchValue = (event) => {
		setSearchValue(event.currentTarget.value)
	}
	//搜索
	const getChearch = (value) => {
		props.getSearch({
			businessIdList,
			sug: value
		})
	}
	// 选业务线
	const changeBusiness = (value) => {
		setBusinessIdList(value)
		props.getSearch({
			businessIdList: value,
			sug: searchValue
		})
	}
	return (
		<div className="lead-business-search">
			<Tooltip
				placement="topLeft"
				title={'景区、民宿商品库需要输入“城市;关键词”，如“北京;天安门”'}
				visible={searchValue.length === 0  && (businessIdList.includes(2) || businessIdList.includes(6))? true : false}
			>
				<Search
					placeholder="请输入需要查找内容的关键词（城市、品牌、主题、商圈、景点、标签等），将从选中的内容库中搜索"
					enterButton="搜索"
					size="middle"
					value={searchValue}
					onChange={e => changeSearchValue(e)}
					onSearch={value => getChearch(value)}
				/>
			</Tooltip>
			<div className="tag-list">
				<span className="label">热搜词：</span>
				{
					tags.map((item, index) => (
						<Tag color="#EFEFEF" key={index} onClick={() => clickTag(item)}>{item}</Tag>
					))
				}
			</div>
			<Checkbox.Group
				defaultValue={businessIdList}
				onChange={changeBusiness}
				options={businessOptions}
			/>
		</div>
	)
}
export default LeadBusinessSearch